export default (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M5.25 2.25C3.59315 2.25 2.25 3.59315 2.25 5.25V18.75C2.25 20.4069 3.59315 21.75 5.25 21.75H18.75C20.4069 21.75 21.75 20.4069 21.75 18.75V5.25C21.75 3.59315 20.4069 2.25 18.75 2.25H5.25ZM6.75 10.875C6.12868 10.875 5.625 11.3787 5.625 12C5.625 12.6213 6.12868 13.125 6.75 13.125H17.25C17.8713 13.125 18.375 12.6213 18.375 12C18.375 11.3787 17.8713 10.875 17.25 10.875H6.75Z"
    fill="currentColor"
  />
);
